import { captureException } from '@/common/store/pinia/telemetry/core/client';
import type { ErrorTrackingProperties } from '@/common/store/pinia/telemetry/core/types';

export const trackError = (error: Error, properties?: Record<string, unknown>): void => {
  captureException(error, properties);
};

export const trackNetworkError = (
  error: Error,
  requestUrl?: string,
  additionalContext?: Record<string, unknown>
): void => {
  const properties: ErrorTrackingProperties = {
    error_type: 'network',
    request_url: requestUrl,
    additional_context: additionalContext
  };

  captureException(error, properties);
};

export const trackBackendError = (
  error: Error,
  statusCode?: number,
  requestUrl?: string,
  errorCode?: string,
  additionalContext?: Record<string, unknown>
): void => {
  const properties: ErrorTrackingProperties = {
    error_type: 'backend',
    status_code: statusCode,
    request_url: requestUrl,
    error_code: errorCode,
    additional_context: additionalContext
  };

  captureException(error, properties);
};
